import { render, staticRenderFns } from "./RootColStyleOne.vue?vue&type=template&id=90da0c02&scoped=true&"
import script from "./RootColStyleOne.vue?vue&type=script&lang=ts&"
export * from "./RootColStyleOne.vue?vue&type=script&lang=ts&"
import style0 from "./RootColStyleOne.vue?vue&type=style&index=0&id=90da0c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da0c02",
  null
  
)

export default component.exports